<div class="configuration-container">
  <p-card header="Access Management Configuration">
    @if (isLoading()) {
      <div class="loading">
        <p-progressSpinner strokeWidth="4" />
      </div>
    } @else {
      <p class="secondary-text">
        Age thresholds used across household membership flows. Whole numbers between 0 and 21.
      </p>

      <div class="field">
        <label for="deviceEligibilityMinAge">Device Eligibility Minimum Age</label>
        <p-inputNumber
          inputId="deviceEligibilityMinAge"
          [min]="0"
          [max]="21"
          [maxFractionDigits]="0"
          [showButtons]="true"
          [ngModel]="configForm.deviceEligibilityMinAge().value()"
          (ngModelChange)="configForm.deviceEligibilityMinAge().value.set($event)"
        />
        @if (configForm.deviceEligibilityMinAge().touched() && !configForm.deviceEligibilityMinAge().valid()) {
          @for (error of configForm.deviceEligibilityMinAge().errors(); track error.kind) {
            <small class="error">{{ error.message }}</small>
          }
        }
      </div>

      <div class="field">
        <label for="hipaaConsentMinAge">HIPAA Consent Minimum Age</label>
        <p-inputNumber
          inputId="hipaaConsentMinAge"
          [min]="0"
          [max]="21"
          [maxFractionDigits]="0"
          [showButtons]="true"
          [ngModel]="configForm.hipaaConsentMinAge().value()"
          (ngModelChange)="configForm.hipaaConsentMinAge().value.set($event)"
        />
        @if (configForm.hipaaConsentMinAge().touched() && !configForm.hipaaConsentMinAge().valid()) {
          @for (error of configForm.hipaaConsentMinAge().errors(); track error.kind) {
            <small class="error">{{ error.message }}</small>
          }
        }
      </div>

      <div class="field">
        <label for="signupMinAge">Signup Minimum Age</label>
        <p-inputNumber
          inputId="signupMinAge"
          [min]="0"
          [max]="21"
          [maxFractionDigits]="0"
          [showButtons]="true"
          [ngModel]="configForm.signupMinAge().value()"
          (ngModelChange)="configForm.signupMinAge().value.set($event)"
        />
        @if (configForm.signupMinAge().touched() && !configForm.signupMinAge().valid()) {
          @for (error of configForm.signupMinAge().errors(); track error.kind) {
            <small class="error">{{ error.message }}</small>
          }
        }
      </div>

      <div class="actions">
        <p-button
          label="Save"
          icon="pi pi-save"
          [loading]="saving()"
          [disabled]="configForm().invalid()"
          (onClick)="onSave()"
        />
      </div>
    }
  </p-card>
</div>
